import { render, staticRenderFns } from "./ServeCenter.vue?vue&type=template&id=23b0aab7&scoped=true&"
import script from "./ServeCenter.vue?vue&type=script&lang=js&"
export * from "./ServeCenter.vue?vue&type=script&lang=js&"
import style0 from "./ServeCenter.vue?vue&type=style&index=0&id=23b0aab7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b0aab7",
  null
  
)

export default component.exports